import React from "react";

const SvgIcons = {
  Home: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"

    >
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  ),
  AddToCart: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-bag-icon lucide-shopping-bag"><path d="M16 10a4 4 0 0 1-8 0" /><path d="M3.103 6.034h17.794" /><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z" /></svg>
  ),
  GoToCart: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-baggage-claim-icon lucide-baggage-claim"><path d="M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2" /><path d="M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10" /><rect width="13" height="8" x="8" y="6" rx="1" /><circle cx="18" cy="20" r="2" /><circle cx="9" cy="20" r="2" /></svg>
  ),
  NavSigninIcon: ({ isSignin }: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M18 20.3423C18 18.751 17.3679 17.2249 16.2426 16.0996C15.1174 14.9744 13.5913 14.3423 12 14.3423C10.4087 14.3423 8.88258 14.9744 7.75736 16.0996C6.63214 17.2249 6 18.751 6 20.3423"
        stroke={isSignin ? "#629A28" : "#000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.3423C14.2091 14.3423 16 12.5514 16 10.3423C16 8.13315 14.2091 6.34229 12 6.34229C9.79086 6.34229 8 8.13315 8 10.3423C8 12.5514 9.79086 14.3423 12 14.3423Z"
        stroke={isSignin ? "#629A28" : "#000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.3423C17.5228 22.3423 22 17.8651 22 12.3423C22 6.81944 17.5228 2.34229 12 2.34229C6.47715 2.34229 2 6.81944 2 12.3423C2 17.8651 6.47715 22.3423 12 22.3423Z"
        stroke={isSignin ? "#629A28" : "#000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  NavCartIcon: ({ isCartPage }: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M8.5 22.3423C9.05228 22.3423 9.5 21.8946 9.5 21.3423C9.5 20.79 9.05228 20.3423 8.5 20.3423C7.94772 20.3423 7.5 20.79 7.5 21.3423C7.5 21.8946 7.94772 22.3423 8.5 22.3423Z"
        stroke={isCartPage ? "#629A28" : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 22.3423C20.0523 22.3423 20.5 21.8946 20.5 21.3423C20.5 20.79 20.0523 20.3423 19.5 20.3423C18.9477 20.3423 18.5 20.79 18.5 21.3423C18.5 21.8946 18.9477 22.3423 19.5 22.3423Z"
        stroke={isCartPage ? "#629A28" : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5498 2.39209H4.5498L7.2098 14.8121C7.30738 15.267 7.56048 15.6736 7.92552 15.9619C8.29056 16.2503 8.74471 16.4024 9.2098 16.3921H18.9898C19.445 16.3914 19.8863 16.2354 20.2408 15.9499C20.5954 15.6645 20.8419 15.2666 20.9398 14.8221L22.5898 7.39209H5.6198"
        stroke={isCartPage ? "#629A28" : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  HomeWhatsappIcon: () => (
    <svg
      className="mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="27"
      viewBox="0 0 110 27"
      fill="none"
    >
      <g clipPath="url(#clip0_1_17050)">
        <path
          d="M107.451 16.6266C107.383 16.9773 107.265 17.2831 107.099 17.546C106.933 17.8084 106.708 18.0274 106.444 18.1853C106.174 18.3491 105.839 18.4311 105.437 18.4311C105.047 18.4311 104.714 18.3491 104.438 18.1853C104.17 18.0291 103.943 17.8099 103.775 17.546C103.61 17.2831 103.488 16.9773 103.413 16.6266C103.339 16.2759 103.301 15.9181 103.302 15.5593C103.302 15.1841 103.337 14.8223 103.405 14.473C103.474 14.1228 103.592 13.8129 103.758 13.5433C103.924 13.2763 104.148 13.052 104.413 12.8878C104.682 12.718 105.017 12.6329 105.42 12.6326C105.81 12.6326 106.14 12.7183 106.409 12.8876C106.677 13.0546 106.904 13.2821 107.072 13.5525C107.245 13.8273 107.369 14.1398 107.443 14.4898C107.518 14.8412 107.555 15.1997 107.555 15.5593C107.555 15.92 107.52 16.2768 107.451 16.6266ZM109.759 13.7801C109.598 13.191 109.351 12.6743 109.018 12.2302C108.685 11.7867 108.267 11.4301 107.762 11.162C107.256 10.8933 106.653 10.759 105.953 10.7593C105.403 10.7593 104.897 10.8697 104.438 11.0917C103.979 11.3138 103.6 11.6701 103.302 12.1605H103.268V11.0038H100.943V23.2304H103.388V18.9393H103.422C103.721 19.3832 104.103 19.7186 104.567 19.9456C105.032 20.1733 105.541 20.2878 106.092 20.2878C106.745 20.2878 107.316 20.1584 107.805 19.9022C108.292 19.6456 108.7 19.3007 109.027 18.8683C109.355 18.4361 109.598 17.9404 109.759 17.3799C109.92 16.8191 110 16.2355 110 15.6283C110 14.986 109.92 14.3705 109.759 13.7801ZM97.7067 16.6266C97.6371 16.9773 97.5191 17.2831 97.3533 17.546C97.1875 17.8087 96.963 18.0278 96.698 18.1853C96.429 18.3491 96.0928 18.4311 95.6912 18.4311C95.3004 18.4311 94.9689 18.3489 94.6933 18.1853C94.4249 18.0295 94.1974 17.8102 94.0301 17.546C93.8636 17.2831 93.7432 16.9773 93.6685 16.6266C93.5939 16.2759 93.5566 15.9181 93.557 15.5593C93.5567 15.1844 93.5908 14.8223 93.6592 14.473C93.7291 14.1225 93.8462 13.8131 94.0131 13.5433C94.1783 13.2761 94.4024 13.0517 94.6677 12.8878C94.9366 12.718 95.2721 12.6329 95.6743 12.6326C96.0642 12.6326 96.3953 12.7183 96.6643 12.8876C96.9325 13.0546 97.1594 13.2821 97.3273 13.5525C97.4992 13.8273 97.6225 14.1398 97.6972 14.4898C97.7724 14.8402 97.8087 15.1968 97.8087 15.5593C97.8092 15.9176 97.775 16.2751 97.7067 16.6266ZM99.2729 12.2302C98.9402 11.7864 98.5211 11.4303 98.0158 11.162C97.5105 10.8933 96.908 10.759 96.2084 10.7593C95.6569 10.7592 95.1519 10.87 94.6933 11.0917C94.2329 11.3139 93.8554 11.67 93.557 12.1605H93.522V11.0038H91.1967V23.2304H93.6433V18.9393H93.6764C93.9746 19.3832 94.3575 19.7186 94.8226 19.9456C95.2867 20.1734 95.7944 20.2875 96.3459 20.2878C97.0005 20.2878 97.5711 20.1584 98.0588 19.9022C98.5468 19.6455 98.9543 19.3009 99.2815 18.8683C99.6091 18.4361 99.8519 17.9404 100.014 17.3799C100.175 16.8106 100.256 16.2208 100.255 15.6283C100.255 14.986 100.173 14.3705 100.014 13.7801C99.8519 13.1911 99.6059 12.6742 99.2729 12.2302ZM83.1912 15.2257L84.7924 10.6363H84.8266L86.3765 15.2257H83.1912ZM83.449 7.55347L78.8004 20.0597H81.521L82.4846 17.2744H87.0825L88.0114 20.0595H90.8188L86.2222 7.55347H83.449ZM78.5935 16.0926C78.4349 15.8088 78.2175 15.5636 77.9563 15.3738C77.6925 15.182 77.3904 15.0268 77.0525 14.9095C76.7104 14.7925 76.3626 14.6935 76.0105 14.6128C75.673 14.5322 75.3345 14.4561 74.9951 14.3845C74.662 14.3141 74.3662 14.2355 74.1078 14.1485C73.8496 14.0607 73.641 13.9475 73.48 13.8061C73.3192 13.6665 73.2389 13.4856 73.2392 13.2636C73.2392 13.0766 73.2839 12.928 73.3763 12.8168C73.4677 12.707 73.5826 12.62 73.7123 12.5625C73.8522 12.5026 74.0002 12.4643 74.1512 12.4489C74.2999 12.4325 74.4492 12.4239 74.5987 12.4233C75.0352 12.4233 75.4143 12.5078 75.7361 12.6768C76.0567 12.8463 76.235 13.1706 76.2689 13.6488H78.5935C78.5477 13.0889 78.4071 12.6246 78.1716 12.256C77.9363 11.8885 77.6407 11.5939 77.2849 11.3722C76.9297 11.1504 76.525 10.9927 76.0706 10.8992C75.6091 10.8049 75.1393 10.7581 74.6686 10.7593C74.1854 10.7593 73.7148 10.8028 73.2566 10.8898C72.7967 10.978 72.3834 11.13 72.0167 11.3458C71.6517 11.5589 71.3463 11.8633 71.1294 12.2302C70.9051 12.6038 70.7934 13.0832 70.7934 13.6665C70.7936 14.0637 70.8742 14.3995 71.0353 14.6738C71.1943 14.947 71.4115 15.1804 71.6711 15.3567C71.9357 15.5377 72.2374 15.6843 72.5758 15.7944C72.9144 15.9065 73.2615 16.0019 73.6169 16.0841C74.4902 16.2711 75.1707 16.4573 75.6579 16.6449C76.1458 16.8314 76.3897 17.1116 76.3897 17.4855C76.3897 17.7072 76.3385 17.8901 76.235 18.0365C76.1332 18.1813 76.0009 18.301 75.8476 18.3869C75.686 18.4772 75.5119 18.542 75.3311 18.5792C75.1415 18.6207 74.9605 18.6414 74.7882 18.6413C74.5472 18.6413 74.315 18.612 74.0917 18.5534C73.8673 18.495 73.6691 18.4045 73.4972 18.2819C73.3235 18.1583 73.1792 17.9966 73.0751 17.8088C72.9668 17.6159 72.9109 17.3863 72.9109 17.1171H70.587C70.6106 17.7243 70.7449 18.2296 70.9924 18.6323C71.2299 19.0264 71.5539 19.3592 71.939 19.6046C72.3234 19.8496 72.7627 20.0248 73.2568 20.1303C73.7497 20.2351 74.255 20.2876 74.7706 20.2876C75.2709 20.2878 75.77 20.2381 76.2608 20.1392C76.7486 20.0399 77.1819 19.8673 77.5608 19.6216C77.9404 19.3769 78.2461 19.0529 78.4823 18.6498C78.717 18.2466 78.8344 17.7473 78.8346 17.1518C78.8346 16.7308 78.7542 16.3784 78.5935 16.0926ZM68.4869 8.28933H66.0413V11.0038H64.5612V12.6676H66.0415V18.0103C66.0418 18.4662 66.1165 18.834 66.2656 19.1136C66.4149 19.3935 66.6184 19.6109 66.8764 19.7623C67.1349 19.914 67.4336 20.016 67.7723 20.0684C68.1285 20.1221 68.4881 20.1484 68.8482 20.1471C69.0901 20.1471 69.3361 20.141 69.5892 20.1303C69.8199 20.1206 70.0497 20.097 70.2776 20.0595V18.1326C70.1624 18.1564 70.0421 18.1746 69.9154 18.1851C69.7895 18.1972 69.6575 18.2033 69.5196 18.2034C69.1067 18.2031 68.8311 18.1328 68.6929 17.9926C68.5557 17.8527 68.4869 17.5725 68.4866 17.1518V12.6676H70.2776V11.0038H68.4869V8.28933ZM61.4789 16.5558C61.479 16.6971 61.4647 16.8842 61.4359 17.1171C61.4073 17.3513 61.3298 17.5809 61.2037 17.8088C61.0771 18.0365 60.8814 18.2327 60.6182 18.3955C60.3544 18.5593 59.9811 18.6413 59.4984 18.6413C59.304 18.6413 59.1141 18.6238 58.9306 18.588C58.7465 18.5534 58.5864 18.4918 58.4485 18.4044C58.3107 18.317 58.2016 18.1973 58.1211 18.0452C58.0412 17.8936 58.0011 17.707 58.0008 17.4855C58.0008 17.2521 58.0414 17.0581 58.1211 16.9071C58.1988 16.7592 58.3077 16.6305 58.4401 16.5305C58.5717 16.4314 58.7266 16.3525 58.9048 16.2936C59.0824 16.2354 59.2633 16.1887 59.4473 16.1538C59.6415 16.1191 59.8366 16.0899 60.0323 16.0662C60.2199 16.0442 60.4066 16.015 60.592 15.9788C60.77 15.9437 60.9366 15.8997 61.0917 15.8468C61.2466 15.7944 61.3753 15.7223 61.4789 15.6283V16.5558ZM63.9238 18.0452V13.334C63.9241 12.7846 63.8035 12.3438 63.562 12.0117C63.3212 11.6786 63.0116 11.4187 62.633 11.2321C62.2535 11.0453 61.8342 10.9197 61.3753 10.8555C60.9247 10.7916 60.4703 10.7595 60.0154 10.7593C59.5218 10.759 59.0312 10.8086 58.5437 10.9081C58.0547 11.0073 57.6166 11.174 57.226 11.4071C56.839 11.6372 56.5092 11.9548 56.2622 12.3353C56.0087 12.7207 55.8656 13.2053 55.8313 13.7893H58.2762C58.3222 13.2984 58.4831 12.9481 58.7589 12.7382C59.0339 12.528 59.4127 12.423 59.8953 12.4233C60.1128 12.4233 60.3165 12.4379 60.5063 12.467C60.6953 12.4963 60.8618 12.554 61.0056 12.6418C61.1494 12.7292 61.2641 12.8519 61.3497 13.01C61.4357 13.1673 61.4789 13.381 61.4789 13.6488C61.4903 13.9066 61.4155 14.1011 61.2554 14.2355C61.0944 14.3706 60.8762 14.4728 60.6008 14.542C60.3254 14.6129 60.0096 14.6654 59.6533 14.6993C59.2908 14.7362 58.9293 14.7832 58.5692 14.8402C58.2009 14.899 57.836 14.978 57.4761 15.0769C57.1147 15.1754 56.7923 15.3251 56.5115 15.5228C56.23 15.7223 56.0006 15.9875 55.822 16.3205C55.6444 16.6536 55.5556 17.0769 55.5556 17.5903C55.5556 18.0573 55.6331 18.46 55.7881 18.7984C55.9428 19.1379 56.1581 19.4171 56.4339 19.6391C56.7095 19.8612 57.0309 20.0249 57.3981 20.1303C57.7651 20.2351 58.1611 20.2876 58.5862 20.2876C59.1375 20.2874 59.6768 20.2059 60.204 20.0429C60.7283 19.8815 61.2029 19.5857 61.5824 19.184C61.5939 19.3359 61.6138 19.4848 61.6421 19.6308C61.6709 19.7761 61.7088 19.9201 61.7545 20.0595H64.2342C64.1192 19.8736 64.0389 19.5934 63.9932 19.2189C63.946 18.8296 63.9228 18.4376 63.9238 18.0452ZM53.8511 11.7834C53.6104 11.462 53.2802 11.2114 52.8619 11.0298C52.4423 10.8496 51.9055 10.7595 51.2517 10.7593C50.7926 10.759 50.3218 10.8788 49.8393 11.1185C49.3573 11.3574 48.9614 11.7398 48.6516 12.2658H48.5998V7.55347H46.1549V20.0597H48.5998V15.3126C48.5998 14.3906 48.7491 13.7278 49.0476 13.3244C49.3458 12.9219 49.8279 12.7206 50.4939 12.7205C51.0791 12.7203 51.4866 12.9044 51.7164 13.2726C51.9461 13.6402 52.0609 14.1977 52.0608 14.9449V20.0592H54.5059V14.4898C54.5058 13.9297 54.4569 13.4188 54.3594 12.9569C54.262 12.4962 54.0925 12.1049 53.8511 11.7832M40.9377 16.171H40.9035L38.803 7.55347H36.2721L34.1366 16.0662H34.1024L32.1568 7.55347H29.4536L32.7079 20.0597H35.4458L37.4944 11.547H37.5287L39.6123 20.0595H42.2985L45.6045 7.55347H42.9529L40.9377 16.171Z"
          fill="black"
        />
        <path
          d="M0.540771 13.7106C0.538207 15.8836 1.09903 18.0189 2.16671 19.9012L0.438721 26.3175L6.89563 24.5958C8.6816 25.5842 10.6825 26.1023 12.7158 26.1027H12.7211C19.4335 26.1027 24.8978 20.5479 24.9006 13.7204C24.9019 10.4118 23.636 7.30102 21.3364 4.96036C19.0371 2.61993 15.979 1.33041 12.7207 1.3291C6.00726 1.3291 0.543564 6.88327 0.540771 13.7106Z"
          fill="url(#paint0_linear_1_17050)"
        />
        <path
          d="M0.105918 13.7067C0.10329 15.9576 0.684196 18.1694 1.79008 20.1191L0 26.7655L6.6883 24.982C8.53825 26.0064 10.611 26.5432 12.7175 26.5435H12.7228C19.676 26.5435 25.3363 20.7888 25.3395 13.717C25.3406 10.2896 24.0292 7.06689 21.6474 4.64234C19.2653 2.21822 16.0978 0.88217 12.7228 0.880859C5.76834 0.880859 0.108711 6.63451 0.105918 13.7067ZM4.08912 19.7842L3.83926 19.3811C2.78904 17.6816 2.23323 15.7146 2.23609 13.7074C2.23824 7.82941 6.94246 3.04738 12.7269 3.04738C15.5278 3.04847 18.1603 4.15883 20.1405 6.17372C22.1205 8.18883 23.21 10.8673 23.2091 13.7161C23.2066 19.5943 18.5026 24.3772 12.7226 24.3772H12.7188C10.8407 24.3773 8.99721 23.864 7.38117 22.8911L6.99811 22.6599L3.0293 23.7183L4.08912 19.7842Z"
          fill="url(#paint1_linear_1_17050)"
        />
        <path
          d="M9.56947 8.34451C9.33314 7.81075 9.08479 7.80004 8.86027 7.79064C8.67637 7.78256 8.46604 7.78322 8.25613 7.78322C8.04559 7.78322 7.7042 7.86362 7.41545 8.18436C7.12648 8.5051 6.31201 9.28051 6.31201 10.858C6.31201 12.4355 7.44166 13.9594 7.59914 14.1735C7.75684 14.3872 9.78002 17.7277 12.9842 19.0126C15.6474 20.0806 16.1892 19.8682 16.7672 19.8147C17.3451 19.7613 18.6324 19.0395 18.895 18.2907C19.1577 17.5422 19.1577 16.9005 19.0789 16.7665C19.0003 16.633 18.7899 16.5526 18.4747 16.3925C18.1594 16.2321 16.6095 15.4565 16.3207 15.3494C16.0315 15.2426 15.8214 15.1893 15.6111 15.5102C15.401 15.8308 14.7973 16.5526 14.6134 16.7665C14.4295 16.9804 14.2453 17.0075 13.9302 16.8474C13.6148 16.6864 12.5994 16.3481 11.395 15.2561C10.4579 14.4062 9.82514 13.357 9.64123 13.0361C9.45732 12.7151 9.62168 12.5419 9.77959 12.3819C9.92139 12.2384 10.095 12.0077 10.2527 11.8204C10.4099 11.6332 10.4626 11.4997 10.5676 11.2858C10.6729 11.0717 10.6201 10.8846 10.5414 10.7243C10.4626 10.5639 9.84984 8.97856 9.56947 8.34451Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_17050"
          x1="1223.53"
          y1="2500.17"
          x2="1223.53"
          y2="1.3291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FAF38" />
          <stop offset="1" stopColor="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_17050"
          x1="1266.98"
          y1="2589.34"
          x2="1266.98"
          y2="0.880859"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_1_17050">
          <rect
            width="110"
            height="26"
            fill="white"
            transform="translate(0 0.880859)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  NavUserIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M18 20.3423C18 18.751 17.3679 17.2249 16.2426 16.0996C15.1174 14.9744 13.5913 14.3423 12 14.3423C10.4087 14.3423 8.88258 14.9744 7.75736 16.0996C6.63214 17.2249 6 18.751 6 20.3423"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.3423C14.2091 14.3423 16 12.5514 16 10.3423C16 8.13315 14.2091 6.34229 12 6.34229C9.79086 6.34229 8 8.13315 8 10.3423C8 12.5514 9.79086 14.3423 12 14.3423Z"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.3423C17.5228 22.3423 22 17.8651 22 12.3423C22 6.81944 17.5228 2.34229 12 2.34229C6.47715 2.34229 2 6.81944 2 12.3423C2 17.8651 6.47715 22.3423 12 22.3423Z"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LoginEditIcon: ({ className }: { className?: string }) => (
    <svg className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M3.94587 13.9454L4.35637 11.0915C4.37886 10.9052 4.46521 10.7326 4.60071 10.6028L12.6543 2.54921C12.7579 2.44365 12.8871 2.36661 13.0292 2.32551C13.1712 2.28442 13.3216 2.28068 13.4655 2.31464C14.2083 2.51253 14.8837 2.90766 15.4203 3.45817C15.9755 3.9926 16.3743 4.66849 16.5736 5.41292C16.6047 5.55699 16.5997 5.70655 16.5587 5.84815C16.5177 5.98976 16.4422 6.11896 16.339 6.22415L8.28543 14.2777C8.14638 14.4057 7.97325 14.4905 7.78696 14.5221L4.92326 14.9326C4.7898 14.9507 4.65397 14.9374 4.52648 14.8941C4.39898 14.8507 4.28331 14.7782 4.18856 14.6826C4.0938 14.5869 4.02256 14.4705 3.98045 14.3426C3.93834 14.2147 3.92651 14.0787 3.94587 13.9454Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1393 4.07389L14.8143 7.73906"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.65057 17.7083H17.3339"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LoginEmail: ({ className }: { className?: string }) => (
    <svg className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.1816 3.5H6.68164C4.4725 3.5 2.68164 5.29086 2.68164 7.5V16.5C2.68164 18.7091 4.4725 20.5 6.68164 20.5H17.1816C19.3908 20.5 21.1816 18.7091 21.1816 16.5V7.5C21.1816 5.29086 19.3908 3.5 17.1816 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2.72876 7.58972L9.934 11.7197C10.5383 12.0708 11.2238 12.2556 11.9216 12.2556C12.6195 12.2556 13.305 12.0708 13.9093 11.7197L21.1344 7.58972"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LoginMobile: ({ className }: { className?: string }) => (
    <svg className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M16.1841 2.83936H7.81578C6.81754 2.83936 6.0083 3.67223 6.0083 4.69964V19.4791C6.0083 20.5065 6.81754 21.3394 7.81578 21.3394H16.1841C17.1823 21.3394 17.9915 20.5065 17.9915 19.4791V4.69964C17.9915 3.67223 17.1823 2.83936 16.1841 2.83936Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.8627C12.2868 18.8627 12.5193 18.6302 12.5193 18.3434C12.5193 18.0567 12.2868 17.8242 12 17.8242C11.7132 17.8242 11.4807 18.0567 11.4807 18.3434C11.4807 18.6302 11.7132 18.8627 12 18.8627Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0027 5.36169H13.9972"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DeliveryIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6_493)">
        <path
          d="M19.0808 10.0007L19.9582 7.71208C20.0545 7.45959 19.9795 7.17336 19.7682 7.00213L17.8659 5.45973L17.4809 3.03865C17.4384 2.77116 17.2284 2.56243 16.9609 2.51993L14.5398 2.13496L12.9987 0.231338C12.8287 0.0201029 12.5362 -0.0548919 12.29 0.0413515L10.0001 0.920041L7.71155 0.0426014C7.45782 -0.0548919 7.17409 0.0226028 7.00285 0.232588L5.46045 2.13621L3.03937 2.52118C2.77314 2.56368 2.56315 2.77366 2.52065 3.0399L2.13568 5.46098L0.23206 7.00338C0.0220746 7.17336 -0.0541702 7.45959 0.0420732 7.71208L0.919513 10.0007L0.0420732 12.2893C-0.0554201 12.5417 0.0220746 12.828 0.23206 12.998L2.13568 14.5391L2.52065 16.9602C2.56315 17.2277 2.77189 17.4377 3.03937 17.4802L5.46045 17.8651L7.00285 19.7675C7.17409 19.98 7.46032 20.055 7.7128 19.9575L10.0001 19.0813L12.2887 19.9587C12.3612 19.9862 12.4362 20 12.5125 20C12.6962 20 12.8774 19.9187 12.9987 19.7675L14.5398 17.8651L16.9609 17.4802C17.2284 17.4377 17.4384 17.2277 17.4809 16.9602L17.8659 14.5391L19.7682 12.998C19.9795 12.8267 20.0545 12.5417 19.9582 12.2893L19.0808 10.0007Z"
          fill="#007F22"
        />
        <path
          d="M8.12512 8.75093C7.09144 8.75093 6.25024 7.90974 6.25024 6.87606C6.25024 5.84238 7.09144 5.00119 8.12512 5.00119C9.1588 5.00119 9.99999 5.84238 9.99999 6.87606C9.99999 7.90974 9.1588 8.75093 8.12512 8.75093ZM8.12512 6.2511C7.78014 6.2511 7.50016 6.53109 7.50016 6.87606C7.50016 7.22104 7.78014 7.50102 8.12512 7.50102C8.47009 7.50102 8.75007 7.22104 8.75007 6.87606C8.75007 6.53109 8.47009 6.2511 8.12512 6.2511Z"
          fill="#FAFAFA"
        />
        <path
          d="M11.8747 15.0004C10.8411 15.0004 9.99988 14.1592 9.99988 13.1255C9.99988 12.0918 10.8411 11.2506 11.8747 11.2506C12.9084 11.2506 13.7496 12.0918 13.7496 13.1255C13.7496 14.1592 12.9084 15.0004 11.8747 15.0004ZM11.8747 12.5005C11.531 12.5005 11.2498 12.7818 11.2498 13.1255C11.2498 13.4692 11.531 13.7504 11.8747 13.7504C12.2185 13.7504 12.4997 13.4692 12.4997 13.1255C12.4997 12.7818 12.2185 12.5005 11.8747 12.5005Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.87513 15.0004C6.74889 15.0004 6.62265 14.9629 6.51266 14.8841C6.23143 14.6829 6.16643 14.2929 6.36767 14.0117L12.6172 5.26229C12.8185 4.98106 13.2084 4.91606 13.4897 5.1173C13.7709 5.31729 13.8347 5.70851 13.6347 5.98849L7.3851 14.7379C7.26136 14.9091 7.07012 15.0004 6.87513 15.0004Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_493">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  UPIICON: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M14.2824 3.64815H5.71762C3.82553 3.64815 2.29169 5.182 2.29169 7.07408V13.9259C2.29169 15.818 3.82553 17.3518 5.71762 17.3518H14.2824C16.1745 17.3518 17.7084 15.818 17.7084 13.9259V7.07408C17.7084 5.182 16.1745 3.64815 14.2824 3.64815Z"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7084 7.93057H2.29169"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.18146 13.9259H9.4639"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PartialCOD: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M16.6667 5.5H3.33335C2.41288 5.5 1.66669 6.24619 1.66669 7.16667V13.8333C1.66669 14.7538 2.41288 15.5 3.33335 15.5H16.6667C17.5872 15.5 18.3334 14.7538 18.3334 13.8333V7.16667C18.3334 6.24619 17.5872 5.5 16.6667 5.5Z"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99998 12.1667C10.9205 12.1667 11.6666 11.4205 11.6666 10.5C11.6666 9.57952 10.9205 8.83333 9.99998 8.83333C9.07951 8.83333 8.33331 9.57952 8.33331 10.5C8.33331 11.4205 9.07951 12.1667 9.99998 12.1667Z"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10.5H5.00833M15 10.5H15.0083"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  WhatsappIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_308_362)">
        <path d="M19.02 0.291433L18.0597 0.157217C15.1737 -0.257746 12.2288 0.152771 9.56818 1.34094C6.90755 2.5291 4.64088 4.44596 3.03242 6.86802C1.32105 9.18322 0.300866 11.9326 0.089254 14.7997C-0.122358 17.6667 0.483232 20.5351 1.8363 23.0746C1.97478 23.3291 2.06098 23.6085 2.08991 23.8965C2.11883 24.1846 2.08989 24.4755 2.00476 24.7523C1.31405 27.1179 0.67387 29.5002 0 32L0.842337 31.7483C3.11665 31.1444 5.39096 30.5404 7.66527 29.9868C8.1453 29.8873 8.64427 29.9341 9.09725 30.121C11.1377 31.1127 13.3676 31.6583 15.6372 31.7212C17.9069 31.7839 20.1637 31.3626 22.2564 30.4854C24.3491 29.6081 26.229 28.2953 27.7704 26.6349C29.3117 24.9745 30.4783 23.005 31.1923 20.8586C31.9064 18.7123 32.151 16.4385 31.9101 14.1902C31.669 11.9418 30.948 9.77085 29.795 7.82288C28.6422 5.87494 27.0844 4.19509 25.2258 2.8961C23.3675 1.5971 21.2515 0.709013 19.02 0.291433ZM23.2654 22.3029C22.6532 22.8488 21.9065 23.2233 21.1016 23.3884C20.2966 23.5534 19.462 23.5029 18.683 23.2424C15.153 22.2526 12.0903 20.0467 10.0407 17.0181C9.25778 15.9469 8.6284 14.7725 8.17067 13.5285C7.92277 12.8068 7.87808 12.0311 8.04141 11.2858C8.20475 10.5405 8.56991 9.85398 9.09725 9.30069C9.35397 8.97439 9.70341 8.73267 10.1001 8.60698C10.4967 8.4813 10.9222 8.47749 11.321 8.59605C11.658 8.67994 11.8938 9.16647 12.197 9.53557C12.4436 10.2283 12.7304 10.9061 13.0562 11.5656C13.3029 11.902 13.406 12.3219 13.3428 12.7336C13.2796 13.1455 13.0556 13.5156 12.7193 13.7634C11.9612 14.4345 12.0791 14.9881 12.6182 15.7431C13.81 17.453 15.4545 18.8002 17.369 19.6353C17.9081 19.8702 18.3124 19.9206 18.6662 19.3669C18.8178 19.1488 19.02 18.9643 19.1884 18.7629C20.1656 17.5382 19.8623 17.555 21.4122 18.2261C21.906 18.4328 22.3844 18.6739 22.8442 18.9475C23.2991 19.2159 23.9898 19.5011 24.0909 19.9038C24.1881 20.3406 24.1625 20.7956 24.0169 21.2189C23.8712 21.6422 23.6112 22.0172 23.2654 22.3029Z" fill="url(#paint0_linear_308_362)" />
        <path d="M19.0214 0.239352C26.9032 1.75516 32.2593 8.58255 31.9903 16.6996C31.7423 24.1828 25.6868 30.7076 18.061 31.6428C14.9507 32.0241 11.958 31.5358 9.10495 30.1944C8.69681 30.0025 8.12902 29.9514 7.68868 30.0569C5.4058 30.6042 3.14062 31.2245 0.868375 31.8159C0.619362 31.8808 0.364557 31.9234 0 32C0.68211 29.5034 1.31933 27.1084 1.99924 24.7258C2.17189 24.1206 2.12426 23.6391 1.84587 23.0477C-0.806159 17.4143 -0.575188 11.8879 3.03766 6.77959C6.66137 1.6559 11.7737 -0.530113 18.0617 0.107962C18.3578 0.138005 18.6525 0.180215 19.0214 0.239352ZM28.9812 18.773C29.4336 16.9259 29.4859 15.0545 29.0456 13.2174C27.7186 7.67998 24.2729 4.09089 18.6718 2.95658C13.1751 1.84345 8.56133 3.69768 5.30585 8.24049C2.04388 12.7923 1.97351 17.6726 4.66475 22.562C5.01079 23.1907 5.10373 23.706 4.8932 24.3781C4.50926 25.6039 4.20992 26.8561 3.83498 28.2469C5.39225 27.8434 6.75857 27.4549 8.1438 27.1524C8.53522 27.0668 9.04914 27.1116 9.39342 27.3012C17.301 31.655 26.7006 27.6387 28.9812 18.773Z" fill="white" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_308_362" x1="16" y1="-3.78319e-07" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stop-color="#57D163" />
          <stop offset="1" stop-color="#23B33A" />
        </linearGradient>
        <clipPath id="clip0_308_362">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  WalletIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M15.8333 6.33333V3.83333C15.8333 3.61232 15.7455 3.40036 15.5893 3.24408C15.433 3.0878 15.221 3 15 3H4.16667C3.72464 3 3.30072 3.17559 2.98816 3.48816C2.67559 3.80072 2.5 4.22464 2.5 4.66667C2.5 5.10869 2.67559 5.53262 2.98816 5.84518C3.30072 6.15774 3.72464 6.33333 4.16667 6.33333H16.6667C16.8877 6.33333 17.0996 6.42113 17.2559 6.57741C17.4122 6.73369 17.5 6.94565 17.5 7.16667V10.5M17.5 10.5H15C14.558 10.5 14.134 10.6756 13.8215 10.9882C13.5089 11.3007 13.3333 11.7246 13.3333 12.1667C13.3333 12.6087 13.5089 13.0326 13.8215 13.3452C14.134 13.6577 14.558 13.8333 15 13.8333H17.5C17.721 13.8333 17.933 13.7455 18.0893 13.5893C18.2455 13.433 18.3333 13.221 18.3333 13V11.3333C18.3333 11.1123 18.2455 10.9004 18.0893 10.7441C17.933 10.5878 17.721 10.5 17.5 10.5Z"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 4.66666V16.3333C2.5 16.7754 2.67559 17.1993 2.98816 17.5118C3.30072 17.8244 3.72464 18 4.16667 18H16.6667C16.8877 18 17.0996 17.9122 17.2559 17.7559C17.4122 17.5996 17.5 17.3877 17.5 17.1667V13.8333"
        stroke="#636363"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CuponSuccess: ({ className }: { className?: string }) => (
    <svg className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M4.22279 8.03345L1.68945 15.1668L8.82279 12.6401"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.02148 2.5H3.02815"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0215 5.83325H15.0282"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3555 1.83325H10.3621"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0215 13.8333H15.0282"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0228 1.83325L13.5295 2.33325C13.1044 2.47484 12.7417 2.75968 12.5033 3.13907C12.265 3.51846 12.1658 3.96885 12.2228 4.41325C12.2895 4.98659 11.8428 5.49992 11.2561 5.49992H11.0028C10.4295 5.49992 9.93612 5.89992 9.82945 6.45992L9.68945 7.16659"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0228 9.16678L14.4761 8.94678C13.9028 8.72012 13.2628 9.08012 13.1561 9.68678C13.0828 10.1534 12.6761 10.5001 12.2028 10.5001H11.6895"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6888 1.83325L7.9088 2.37992C8.13547 2.95325 7.77547 3.59325 7.1688 3.69992C6.70214 3.76659 6.35547 4.17992 6.35547 4.65325V5.16659"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.68784 9.1666C8.9745 10.4533 9.5745 11.9466 9.02117 12.4999C8.46784 13.0533 6.9745 12.4533 5.68784 11.1666C4.40117 9.87993 3.80117 8.3866 4.3545 7.83326C4.90784 7.27993 6.40117 7.87993 7.68784 9.1666Z"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SecureBadge: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_34_668)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5419 1.13836L12.7327 2.02977C13.0584 2.27355 13.4012 2.39832 13.8074 2.42094L15.2926 2.50355C16.182 2.55301 16.9043 3.15906 17.1074 4.02633L17.4467 5.47465C17.5395 5.87074 17.7219 6.18668 18.0185 6.46508L19.1032 7.48309C19.7526 8.09262 19.9163 9.02117 19.5145 9.81609L18.8435 11.1436C18.66 11.5067 18.5966 11.866 18.6449 12.2699L18.8215 13.747C18.9272 14.6314 18.4557 15.4479 17.637 15.7986L16.2695 16.3842C15.8956 16.5443 15.6161 16.7788 15.3935 17.1193L14.5793 18.3642C14.0918 19.1096 13.2058 19.4321 12.3532 19.1745L10.9293 18.7441C10.5399 18.6264 10.1751 18.6264 9.7856 18.7441L8.3617 19.1745C7.50912 19.4321 6.6231 19.1096 6.1356 18.3642L5.32142 17.1193C5.09873 16.7788 4.81927 16.5443 4.44533 16.3842L3.07783 15.7985C2.25908 15.4478 1.78763 14.6313 1.89334 13.7469L2.0699 12.2698C2.11818 11.8659 2.05482 11.5066 1.8713 11.1436L1.20025 9.81602C0.798452 9.02113 0.962163 8.09258 1.61162 7.48301L2.69626 6.465C2.99291 6.1866 3.17529 5.87066 3.26806 5.47457L3.60736 4.02625C3.81048 3.15902 4.53279 2.55297 5.42212 2.50348L6.90732 2.42086C7.31353 2.39828 7.65634 2.27348 7.98205 2.02969L9.17291 1.13828C9.88591 0.604609 10.8288 0.604609 11.5419 1.13836ZM9.59771 10.5102L8.30537 9.21785C7.97041 8.88289 7.42709 8.88289 7.09216 9.21785C6.7572 9.55281 6.7572 10.0961 7.09216 10.4311L8.99298 12.3318C9.32795 12.6668 9.87127 12.6668 10.2062 12.3318C11.3519 11.1861 12.4846 10.0275 13.6251 8.87652C13.9576 8.5409 13.9565 7.99934 13.6213 7.66602C13.2861 7.33262 12.743 7.33355 12.4101 7.66977L9.59771 10.5102ZM10.3574 3.61152C8.59326 3.61152 6.99611 4.3266 5.84002 5.4827C4.68392 6.63883 3.96884 8.23594 3.96884 10C3.96884 11.7641 4.68392 13.3613 5.84002 14.5174C6.99611 15.6735 8.59326 16.3886 10.3574 16.3886C12.1215 16.3886 13.7186 15.6735 14.8747 14.5174C16.0308 13.3613 16.7459 11.7641 16.7459 10C16.7459 8.23594 16.0308 6.63879 14.8747 5.4827C13.7186 4.3266 12.1215 3.61152 10.3574 3.61152ZM14.4328 5.92461C13.3898 4.88164 11.9489 4.23652 10.3574 4.23652C8.7658 4.23652 7.3249 4.88164 6.28193 5.92461C5.23896 6.96758 4.59384 8.40848 4.59384 10C4.59384 11.5916 5.23896 13.0325 6.28193 14.0755C7.3249 15.1184 8.7658 15.7636 10.3574 15.7636C11.9489 15.7636 13.3898 15.1184 14.4328 14.0755C15.4758 13.0325 16.1208 11.5916 16.1208 10.0001C16.1209 8.40848 15.4758 6.96758 14.4328 5.92461Z"
          fill="#8B8B8B"
        />
      </g>
      <defs>
        <clipPath id="clip0_34_668">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  SummeryClose: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-chevron-down"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  ),
  SummeryOpen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-chevron-up"
    >
      <path d="m18 15-6-6-6 6" />
    </svg>
  ),
  CouponAppliedIcon: () => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 130.2 130.2"
    >
      <circle
        className="path circle"
        fill="none"
        stroke="#fdd734"
        strokeWidth={8}
        strokeMiterlimit={10}
        cx="65.1"
        cy="65.1"
        r="60.1"
      />
      <polyline
        className="path check"
        fill="none"
        stroke="#fdd734"
        strokeWidth={8}
        strokeLinecap="round"
        strokeMiterlimit={10}
        points="100.2,40.2 51.5,88.8 29.8,67.5 "
      />
    </svg>
  ),
  CartDeleteIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-trash-2"
    >
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      <line
        x1="10"
        x2="10"
        y1="11"
        y2="17"
      />
      <line
        x1="14"
        x2="14"
        y1="11"
        y2="17"
      />
    </svg>
  ),
  CommonBackIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-arrow-left"
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  ),
  SigninMyaccount: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="mr-2"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  CheckOutEstimateIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4805 15.6251H14.5213C13.2555 15.6251 12.2296 14.5992 12.2296 13.3334V11.6667C12.2296 10.4009 13.2555 9.37508 14.5213 9.37508H18.4805V8.33342C18.4805 7.72591 18.2388 7.14258 17.8096 6.71258C17.3796 6.28342 16.7963 6.04175 16.1888 6.04175C13.303 6.04175 7.40797 6.04175 4.52214 6.04175C3.91464 6.04175 3.3313 6.28342 2.9013 6.71258C2.47214 7.14258 2.23047 7.72591 2.23047 8.33342V16.6667C2.23047 17.2742 2.47214 17.8576 2.9013 18.2876C3.3313 18.7167 3.91464 18.9584 4.52214 18.9584H16.1888C16.7963 18.9584 17.3796 18.7167 17.8096 18.2876C18.2388 17.8576 18.4805 17.2742 18.4805 16.6667V15.6251ZM18.4805 10.6251V14.3751H14.5213C13.9463 14.3751 13.4796 13.9084 13.4796 13.3334V11.6667C13.4796 11.0917 13.9463 10.6251 14.5213 10.6251H18.4805ZM14.9388 11.6667C15.3988 11.6667 15.7721 12.0401 15.7721 12.5001C15.7721 12.9601 15.3988 13.3334 14.9388 13.3334C14.4788 13.3334 14.1055 12.9601 14.1055 12.5001C14.1055 12.0401 14.4788 11.6667 14.9388 11.6667Z"
        fill="#24B218"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7631 5.20843H16.1897C16.3489 5.20843 16.5072 5.22093 16.6631 5.24427L17.0581 4.39593C17.2039 4.08343 17.0689 3.71177 16.7564 3.56593L11.4689 1.1001C11.1564 0.954268 10.7847 1.0901 10.6389 1.4026L10.1914 2.36177L12.9414 3.64343C13.5497 3.9276 13.8706 4.5776 13.7631 5.20843Z"
        fill="#24B218"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08398 5.20835H12.8998C13.0298 4.90002 12.894 4.54169 12.5882 4.39919L7.30065 1.93335C6.98815 1.78752 6.61648 1.92335 6.47065 2.23585L5.08398 5.20835Z"
        fill="#24B218"
      />
    </svg>
  ),
  CartOfferIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6_493)">
        <path
          d="M19.0808 10.0007L19.9582 7.71208C20.0545 7.45959 19.9795 7.17336 19.7682 7.00213L17.8659 5.45973L17.4809 3.03865C17.4384 2.77116 17.2284 2.56243 16.9609 2.51993L14.5398 2.13496L12.9987 0.231338C12.8287 0.0201029 12.5362 -0.0548919 12.29 0.0413515L10.0001 0.920041L7.71155 0.0426014C7.45782 -0.0548919 7.17409 0.0226028 7.00285 0.232588L5.46045 2.13621L3.03937 2.52118C2.77314 2.56368 2.56315 2.77366 2.52065 3.0399L2.13568 5.46098L0.23206 7.00338C0.0220746 7.17336 -0.0541702 7.45959 0.0420732 7.71208L0.919513 10.0007L0.0420732 12.2893C-0.0554201 12.5417 0.0220746 12.828 0.23206 12.998L2.13568 14.5391L2.52065 16.9602C2.56315 17.2277 2.77189 17.4377 3.03937 17.4802L5.46045 17.8651L7.00285 19.7675C7.17409 19.98 7.46032 20.055 7.7128 19.9575L10.0001 19.0813L12.2887 19.9587C12.3612 19.9862 12.4362 20 12.5125 20C12.6962 20 12.8774 19.9187 12.9987 19.7675L14.5398 17.8651L16.9609 17.4802C17.2284 17.4377 17.4384 17.2277 17.4809 16.9602L17.8659 14.5391L19.7682 12.998C19.9795 12.8267 20.0545 12.5417 19.9582 12.2893L19.0808 10.0007Z"
          fill="#007F22"
        />
        <path
          d="M8.12512 8.75093C7.09144 8.75093 6.25024 7.90974 6.25024 6.87606C6.25024 5.84238 7.09144 5.00119 8.12512 5.00119C9.1588 5.00119 9.99999 5.84238 9.99999 6.87606C9.99999 7.90974 9.1588 8.75093 8.12512 8.75093ZM8.12512 6.2511C7.78014 6.2511 7.50016 6.53109 7.50016 6.87606C7.50016 7.22104 7.78014 7.50102 8.12512 7.50102C8.47009 7.50102 8.75007 7.22104 8.75007 6.87606C8.75007 6.53109 8.47009 6.2511 8.12512 6.2511Z"
          fill="#FAFAFA"
        />
        <path
          d="M11.8747 15.0004C10.8411 15.0004 9.99988 14.1592 9.99988 13.1255C9.99988 12.0918 10.8411 11.2506 11.8747 11.2506C12.9084 11.2506 13.7496 12.0918 13.7496 13.1255C13.7496 14.1592 12.9084 15.0004 11.8747 15.0004ZM11.8747 12.5005C11.531 12.5005 11.2498 12.7818 11.2498 13.1255C11.2498 13.4692 11.531 13.7504 11.8747 13.7504C12.2185 13.7504 12.4997 13.4692 12.4997 13.1255C12.4997 12.7818 12.2185 12.5005 11.8747 12.5005Z"
          fill="#FAFAFA"
        />
        <path
          d="M6.87513 15.0004C6.74889 15.0004 6.62265 14.9629 6.51266 14.8841C6.23143 14.6829 6.16643 14.2929 6.36767 14.0117L12.6172 5.26229C12.8185 4.98106 13.2084 4.91606 13.4897 5.1173C13.7709 5.31729 13.8347 5.70851 13.6347 5.98849L7.3851 14.7379C7.26136 14.9091 7.07012 15.0004 6.87513 15.0004Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_493">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  SigninHome: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-house-heart-icon lucide-house-heart"><path d="M8.62 13.8A2.25 2.25 0 1 1 12 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z" /><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
  ),
  ExitIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-log-out-icon lucide-log-out"><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /></svg>
  ),

  LeftArrow: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-left-icon lucide-chevron-left"><path d="m15 18-6-6 6-6" /></svg>
  ),
  RightArrow: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right-icon lucide-chevron-right"><path d="m9 18 6-6-6-6" /></svg>
  ),

  SRIconone: () => (
    <svg height="50" viewBox="0 0 28 28" width="50" xmlns="http://www.w3.org/2000/svg" id="fi_4575124"><g id="Layer_2" data-name="Layer 2"><path d="m26.186 5.536-5-2a.5.5 0 0 0 -.372 0l-5 2a.5.5 0 0 0 -.314.464v5.168a5.529 5.529 0 0 0 2.671 4.718l2.572 1.543a.5.5 0 0 0 .514 0l2.243-1.346v5.6a.821.821 0 0 1 -.82.82h-19.36a.821.821 0 0 1 -.82-.82v-11.183h11.5a.5.5 0 0 0 0-1h-11.5v-1.18a.821.821 0 0 1 .82-.82h10.68a.5.5 0 0 0 0-1h-10.68a1.821 1.821 0 0 0 -1.82 1.82v13.36a1.821 1.821 0 0 0 1.82 1.82h19.36a1.821 1.821 0 0 0 1.82-1.82v-6.28a5.529 5.529 0 0 0 2-4.234v-5.166a.5.5 0 0 0 -.314-.464zm-.686 5.632a4.522 4.522 0 0 1 -2.186 3.86l-2.314 1.389-2.314-1.389a4.522 4.522 0 0 1 -2.186-3.86v-4.83l4.5-1.8 4.5 1.8z"></path><path d="m19.354 9.732a.5.5 0 0 0 -.708.707l1.334 1.333a.5.5 0 0 0 .707 0l2.667-2.667a.5.5 0 0 0 -.708-.707l-2.313 2.314z"></path><path d="m5 19.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"></path></g></svg>
  ),

  SRIcontwo: () => (
    <svg id="fi_2279674" height="50" viewBox="0 0 128 128" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m14.227 89.655c-.736-1.442-1.417-2.931-2.026-4.426a1.5 1.5 0 1 0 -2.779 1.13c.64 1.575 1.358 3.142 2.133 4.66a1.5 1.5 0 0 0 2.672-1.364z"></path><path d="m10.559 80.646c-.482-1.547-.9-3.131-1.247-4.708a1.5 1.5 0 0 0 -2.93.643c.364 1.66.805 3.327 1.311 4.956a1.5 1.5 0 0 0 2.866-.891z"></path><path d="m7.178 72.826a1.5 1.5 0 0 0 1.291-1.683c-.212-1.6-.358-3.23-.436-4.853a1.481 1.481 0 0 0 -1.569-1.427 1.5 1.5 0 0 0 -1.427 1.57c.081 1.707.235 3.423.457 5.1a1.5 1.5 0 0 0 1.684 1.291z"></path><path d="m33.4 111.312c-1.341-.906-2.66-1.878-3.921-2.894a1.5 1.5 0 1 0 -1.88 2.338c1.326 1.066 2.712 2.091 4.124 3.042a1.5 1.5 0 0 0 2.082-.4 1.5 1.5 0 0 0 -.405-2.086z"></path><path d="m16.621 93.9a1.5 1.5 0 1 0 -2.547 1.584c.9 1.443 1.868 2.867 2.886 4.233a1.5 1.5 0 1 0 2.406-1.793c-.966-1.304-1.891-2.657-2.745-4.024z"></path><path d="m22.437 101.7a1.5 1.5 0 1 0 -2.246 1.989c1.131 1.276 2.328 2.517 3.557 3.69a1.5 1.5 0 1 0 2.07-2.17c-1.169-1.118-2.306-2.299-3.381-3.509z"></path><path d="m65.584 2.9a60.737 60.737 0 0 0 -49.584 25.744 1.5 1.5 0 0 0 2.453 1.728 57.6 57.6 0 1 1 23.447 85.682c-1.47-.664-2.934-1.4-4.35-2.192a1.5 1.5 0 1 0 -1.463 2.619c1.491.832 3.031 1.609 4.579 2.307a60.621 60.621 0 1 0 24.918-115.888z"></path><path d="m16.451 34.611a4.177 4.177 0 0 1 -4.115-3.506l-1.248-7.749a1.5 1.5 0 0 1 2.961-.476l1.251 7.748a1.177 1.177 0 0 0 1.342.969l7.748-1.248a1.5 1.5 0 0 1 .476 2.961l-7.748 1.248a4.156 4.156 0 0 1 -.667.053z"></path><path d="m104.324 37.894-36.447-19.207a4.8 4.8 0 0 0 -4.487 0l-36.449 19.207a4.8 4.8 0 0 0 -2.569 4.257v42.725a4.8 4.8 0 0 0 2.569 4.258l36.449 19.207a4.812 4.812 0 0 0 4.487 0l36.447-19.207a4.8 4.8 0 0 0 2.57-4.258v-42.725a4.8 4.8 0 0 0 -2.57-4.257zm-52.91 12.306a4.789 4.789 0 0 0 -2.64 4.294v17.14a.135.135 0 0 1 -.1.145.132.132 0 0 1 -.171-.037l-3.278-3.422a3.179 3.179 0 0 0 -2.946-.9l-2.139.461a.157.157 0 0 1 -.189-.153v-19.216a1.8 1.8 0 0 1 .994-1.617l37.76-19.111 8.328 4.389zm13.374-28.86a1.815 1.815 0 0 1 1.691 0l8.972 4.728-35.858 18.15a4.779 4.779 0 0 0 -1.007.688l-9.445-4.781zm-.655 84-35.793-18.861a1.806 1.806 0 0 1 -.968-1.6v-42.287l9.7 4.908a4.787 4.787 0 0 0 -.118 1.012v19.213a3.157 3.157 0 0 0 3.82 3.086l2.139-.46a.144.144 0 0 1 .147.045l3.28 3.422a3.156 3.156 0 0 0 5.435-2.183v-16.692l11.687 5.914a4.633 4.633 0 0 0 .672.272zm.683-47.159-11.263-5.7 36.734-18.593 11.839 6.238-35.673 18.056a1.822 1.822 0 0 1 -1.637 0zm39.078 26.694a1.808 1.808 0 0 1 -.968 1.6l-35.793 18.867v-44.212a4.731 4.731 0 0 0 .676-.273l36.085-18.264z"></path></svg>
  ),


  SRIconthree: () => (
    <svg
      id="fi_10206634"
      height="50"
      width="50"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        style={{
          fill: "none",
          stroke: "#010101",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 10,
          strokeWidth: 1.938,
        }}
      >
        <path d="m18.9 51.2c-10.4-3.3-17.9-13-17.9-24.5 0-1.9.2-3.7.6-5.4 1.9-8.8 8.2-15.8 16.4-18.8 2.7-1 5.6-1.5 8.7-1.5 5.9 0 11.4 2 15.7 5.4 2.7 2 4.9 4.6 6.6 7.5 2.2 3.8 3.4 8.1 3.4 12.8 0 .7 0 1.3-.1 2" />
        <path d="m20.1 4.7c.2.2.4.5.5.8-.2-.3-.4-.6-.5-.8 0-.1 0 0 0 0z" />
        <path d="m20.1 4.6-.1-.1s0 0 .1.1c-.1-.1-.1 0 0 0z" />
        <path d="m20.8 5.7c.4 1.2.2 2.7-.1 4 1.2-.9 2.5-1.8 3.9-1.9 1.5-.1 3.2.8 3.3 2.3.1.8-.4 1.6-.2 2.4.2.7.8 1.1 1.2 1.6.5.5.8 1.2.5 1.8-.7 1.2-3.1.2-3.7 1.5-.3.7.2 1.5.9 1.9.6.4 1.3.9 1.5 1.6.3 1.1-.9 2.1-2.1 2.1s-2.2-.6-3.2-1.1c-1.3-.6-2.7-1-4.2-1-1.4.1-2.9.7-3.7 1.9-1.1 1.6-.9 3.7-1.1 5.7s-1.1 4.2-3 4.5c-1.6.2-3-1.1-3.6-2.6s-.6-3.1-.8-4.7c-.2-1-.5-2.1-1.1-2.9" />
        <path d="m23.3 27.6c.1 0 .1.7 0 1.3" />
        <path d="m23.3 27.6c1-.2 2 .2 2.7.8" />
        <path d="m43.1 28.4c.1-.6-.1-1.1-.5-1.5-.6-.5-1.5-.4-2.2-.7-1.1-.6-1.2-2.4-.2-3.3.9-.9 2.5-.9 3.6-.3 1.2.6 2 1.6 2.8 2.6.6.9 1.2 1.9 2 2.7" />
        <path d="m38.9 8.6c-.1.3-.3.6-.3 1-.2.9-.1 1.9 0 2.8.1.7.2 1.5.8 1.9.8.5 2-.1 3 .2s1.5 1.6 2.5 2c.4.1.7.1 1.1 0" />
        <path d="m63 47.4v10.8c0 1-.8 1.9-1.9 1.9h-1.9c0-.1 0-.3 0-.4 0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v.4h-17.6c0-.1 0-.3 0-.4 0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v.4h-3.5c-1 0-1.9-.8-1.9-1.9v-4.1h30.3v-13.4h3.2c.7 0 1.5.3 2 .8l3.9 3.9c.7.6 1 1.3 1 2z" />
        <path d="m53.1 35.1v19h-30.3v-19c0-1.5 1.2-2.8 2.8-2.8h24.7c1.6 0 2.8 1.2 2.8 2.8z" />
        <circle cx="31.5" cy="59.6" r="3.4" />
        <circle cx="56" cy="59.6" r="3.4" />
      </g>
    </svg>
  )


}

export default SvgIcons;